import AxiosInstance from "src/api/AxiosInstance";
import { handleApiError } from "src/api/ErrorHandler";
import { ListParam } from "src/types/api/listParam";


export const getBlogAmount = async ( params : ListParam ) => {
    try {
        const response = await AxiosInstance.get("/blog/cumulative", {
            params: params
        });
        return response.data;
    } catch (error) {
        handleApiError("blog 데이터 불러오기 실패:");
        throw error;
    }
};

export const getBlogLatest = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get("/blog/latest", {
            params: params
        });
        return response.data;
    } catch (error) {
        handleApiError("blog 데이터 불러오기 실패:");
        throw error;
    }
};